
console.log('Custom Media Slideshow JS loaded');

document.addEventListener('DOMContentLoaded', () => {
  const slideshow = document.querySelector('.custom-media-slideshow');
  if (!slideshow) return;

  const slides = Array.from(slideshow.querySelectorAll('.custom-media-slide'));
  const prevButton = slideshow.parentElement.querySelector('.slider-button--prev');
  const nextButton = slideshow.parentElement.querySelector('.slider-button--next');
  const paginationDots = Array.from(document.querySelectorAll('.slider-counter__link'));
  const autoplayButton = document.querySelector('.slideshow__autoplay');

  const transitionType = slideshow.dataset.transition;
  const imageDuration = parseInt(slideshow.dataset.imageDuration, 10) || 5;
  let currentIndex = 0;
  let isPaused = false;
  let autoplayTimeout = null;

  function updateActiveDot() {
    paginationDots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  }

  function resetSlidePosition(slide) {
    if (transitionType === 'slide') {
      slide.style.transition = 'none';
      slide.style.transform = 'translateX(100%)';
      void slide.offsetWidth;
      slide.style.transition = '';
    }
  }

  async function getSlideDuration(slide) {
    const video = slide.querySelector('video');
    if (video) {
      return new Promise((resolve) => {
        if (video.readyState >= 1) {
          video.currentTime = 0;
          video.play();
          resolve(video.duration * 1000);
        } else {
          video.addEventListener('loadedmetadata', () => {
            video.currentTime = 0;
            video.play();
            resolve(video.duration * 1000);
          }, { once: true });
        }
      });
    }
    return Promise.resolve(imageDuration * 1000);
  }

  async function showSlide(nextIndex) {
    clearTimeout(autoplayTimeout);

    if (nextIndex === currentIndex) return;

    const currentSlide = slides[currentIndex];
    const nextSlide = slides[nextIndex];

    if (transitionType === 'slide') {
      nextSlide.style.transition = 'none';
      nextSlide.style.transform = 'translateX(100%)';
      void nextSlide.offsetWidth;
      nextSlide.style.transition = '';

      currentSlide.style.transform = 'translateX(-100%)';
      nextSlide.style.transform = 'translateX(0)';

      currentSlide.dataset.active = "false";
      nextSlide.dataset.active = "true";

      setTimeout(() => {
        resetSlidePosition(currentSlide);
      }, 1000);
    } else {
      currentSlide.dataset.active = "false";
      nextSlide.dataset.active = "true";
    }

    currentIndex = nextIndex;
    updateActiveDot();

    if (!isPaused) autoplayLoop();
  }

  async function autoplayLoop() {
    clearTimeout(autoplayTimeout);
    if (isPaused) return;

    const currentSlide = slides[currentIndex];
    const duration = await getSlideDuration(currentSlide);

    autoplayTimeout = setTimeout(() => {
      const video = currentSlide.querySelector('video');
      if (video) video.pause();

      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }, duration);
  }

  function pauseSlideshow() {
    isPaused = true;
    clearTimeout(autoplayTimeout);
    autoplayButton.classList.add('slideshow__autoplay--paused');
    const video = slides[currentIndex].querySelector('video');
    if (video) video.pause();
  }

  function playSlideshow() {
    if (!isPaused) return;
    isPaused = false;
    autoplayButton.classList.remove('slideshow__autoplay--paused');
    const video = slides[currentIndex].querySelector('video');
    if (video) video.play();
    autoplayLoop();
  }

  autoplayButton.addEventListener('click', () => {
    if (isPaused) {
      playSlideshow();
    } else {
      pauseSlideshow();
    }
  });

  prevButton.addEventListener('click', () => {
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(prevIndex);
  });

  nextButton.addEventListener('click', () => {
    const nextIndex = (currentIndex + 1) % slides.length;
    showSlide(nextIndex);
  });

  paginationDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      if (index === currentIndex) return; // Prevent glitch on active dot
      showSlide(index);
    });
  });

  function initializeSlideshow() {
    slides.forEach((slide, index) => {
      slide.dataset.active = index === 0 ? "true" : "false";
      if (transitionType === 'slide' && index !== 0) {
        resetSlidePosition(slide);
      }
    });
    updateActiveDot();
    autoplayLoop();
  }

  initializeSlideshow();
});
